import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { IconWrapper } from "../../IconWrapper/index.js";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index53.css';const modalHeader = "_modalHeader_d9i5x_2";
const leftIcon = "_leftIcon_d9i5x_11";
const leftSection = "_leftSection_d9i5x_15";
const mainSection = "_mainSection_d9i5x_21";
const label = "_label_d9i5x_31";
const caption = "_caption_d9i5x_44";
const rightSection = "_rightSection_d9i5x_58";
const sticky = "_sticky_d9i5x_65";
const s = {
  modalHeader,
  leftIcon,
  leftSection,
  mainSection,
  label,
  caption,
  rightSection,
  sticky
};
const Header = withThemeAndSize(
  forwardRef(
    ({
      className,
      children,
      caption: caption2,
      label: label2,
      leftSection: leftSection2,
      rightSection: rightSection2,
      mainSectionClassName,
      labelClassName,
      captionClassName,
      leftSectionClassName,
      rightSectionClassName,
      leftIconClassName,
      leftIcon: leftIcon2,
      sticky: sticky2,
      ...rest
    }, ref) => /* @__PURE__ */ jsxs("header", { ...rest, className: clsx(s.modalHeader, className, { [s.sticky]: sticky2 }), ref, children: [
      leftIcon2 && /* @__PURE__ */ jsx(IconWrapper, { size: "lg", className: clsx(s.leftIcon, leftIconClassName), children: leftIcon2 }),
      leftSection2 && /* @__PURE__ */ jsx("span", { className: clsx(s.leftSection, leftSectionClassName), children: leftSection2 }),
      /* @__PURE__ */ jsxs("span", { className: clsx(s.mainSection, mainSectionClassName), children: [
        children,
        label2 && /* @__PURE__ */ jsx("span", { className: clsx(s.label, labelClassName), children: label2 }),
        caption2 && /* @__PURE__ */ jsx("span", { className: clsx(s.caption, captionClassName), children: caption2 })
      ] }),
      rightSection2 && /* @__PURE__ */ jsx("span", { className: clsx(s.rightSection, rightSectionClassName), children: rightSection2 })
    ] })
  )
);
Header.displayName = "Modal.Header";
export {
  Header
};
